import type { FaireProductEntity } from "../../entity_types/product";

export const p_st73wmcpw2: FaireProductEntity = {
  token: "p_st73wmcpw2",
  type: "product",
  name: "One White Onyx Palo Santo and Incense Holder",
  brandToken: "b_pqhb98yzxr",
  brandName: "Mi Esperanza Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/b720ccfdd64e9a71fb00c90ca3be4a01225943029a2ec4558736c290ff418b60.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46f72a6cee066a0de8c944ebc3ebd1c4004753ff69669709b24024c3893033a9.jpeg",
    "https://cdn.faire.com/fastly/0a0d71ae532518ca555ef539bd70eb0cc4653e60ff5d47bccd1a56211417aaaf.jpeg",
    "https://cdn.faire.com/fastly/cf04e46a4b187805ad94dfd0fd53db6ab65d67f4ff1b831680803f6838a84812.jpeg",
    "https://cdn.faire.com/fastly/2a4148fe179f6c98d3409462f04d48c5d05638f49cc92ad16b86fa5c06c0efba.jpeg",
    "https://cdn.faire.com/fastly/5d5993d29dd247ddff060c0be1f31ce16a3be560d9c8d11b860e7140e1891a93.jpeg",
    "https://cdn.faire.com/fastly/22a4b97f661211c5811c62d14b40dadc14c9a71d0cfb6a6560fc6869ec3dfffb.jpeg",
    "https://cdn.faire.com/fastly/0d027007195c5cdbc7d48e2c5912ebe65624ea020347d01e2c0c821ed1a29b5a.jpeg",
  ],
  priceDollars: 19.4,
  description:
    'You will receive a 1 White Onyx Palo Santo Holder approximately the same size and quality as the ones pictured. Note that patterns and shades may vary. \nNote: All props shown in the photo are not included, they are only present for display purposes only. You will only receive 1 Onyx Holder. \n\n\nL x W x H: 4.75" x 4.75" x 1.25".\n',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:45.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
